// extracted by mini-css-extract-plugin
export default {"form":"lp","inline":"mp","inputWrapper":"np","input":"op","withoutLabel":"pp","error":"qp","label":"rp"};